import { EVENTBRITE_CATEGORY } from './constants';

export function isCategory(target: string) {
    return target.startsWith(EVENTBRITE_CATEGORY);
}
